import React, { useEffect, useState, useContext } from "react";
import { ServerContext } from "../App";
import { getMatchesCard } from "../services/ScheduleService";
import Pagination from "../components/shared/Pagination";

function Schedule() {
    const { selectedServerIds } = useContext(ServerContext);
    const [matches, setMatches] = useState([]);
    const [activeFilter, setActiveFilter] = useState("today");
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const PAGE_SIZE = 10;

    const fetchData = (page, range) => {
        setLoading(true);
        getMatchesCard("upcoming", page, PAGE_SIZE, range, selectedServerIds).then((data) => {
            if (data && data.matches) {
                setMatches(data.matches);
                setTotalPages(data.totalPages);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        fetchData(0, activeFilter);
        const interval = setInterval(() => fetchData(currentPage, activeFilter), 30000);
        return () => clearInterval(interval);
    }, [selectedServerIds]);

    const handleFilterChange = (filter) => {
        setActiveFilter(filter);
        setCurrentPage(0);
        fetchData(0, filter);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, activeFilter);
    };

    const formatTime = (startTime) => {
        if (!startTime) return "--:--";
        const date = new Date(startTime);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const getDateLabel = (startTime, index) => {
        if (index === 0) return "Next";
        if (!startTime) return "Today";
        const date = new Date(startTime);
        const now = new Date();
        const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        const tomorrowEnd = new Date(todayEnd);
        tomorrowEnd.setDate(tomorrowEnd.getDate() + 1);
        if (date <= todayEnd) return "Today";
        if (date <= tomorrowEnd) return "Tomorrow";
        return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
    };

    const getTeamName = (match, index) => {
        if (index === 0) return match.team1Name || "TBD";
        return match.team2Name || "TBD";
    };

    return (
        <div id="section-schedule" className={`spanel active ${loading ? "page-loading" : "page-default"}`}>
            <div className="main-wrap main-wrap-padded">
                <div className="fbar">
                    <button className={`fbtn ${activeFilter === "today" ? "active" : ""}`} onClick={() => handleFilterChange("today")}>Today</button>
                    <button className={`fbtn ${activeFilter === "tomorrow" ? "active" : ""}`} onClick={() => handleFilterChange("tomorrow")}>Tomorrow</button>
                    <button className={`fbtn ${activeFilter === "week" ? "active" : ""}`} onClick={() => handleFilterChange("week")}>This Week</button>
                </div>
                <div className="sh">Upcoming Virtual IPL Matches</div>

                {!loading && matches.length === 0 && (
                    <p className="no-matches-msg">No upcoming matches found.</p>
                )}

                {matches.map((match, index) => (
                    <div className="sched-card" key={match.matchId}>
                        <div className="sched-time-blk">
                            <div className="st-label">{getDateLabel(match.matchStartTime, index)}</div>
                            <div className="st-time">{formatTime(match.matchStartTime)}</div>
                            <div className="st-date">{getDateLabel(match.matchStartTime, -1)}</div>
                        </div>
                        <div className="sched-main">
                            <div className="sched-teams">
                                {getTeamName(match, 0)}
                                <span className="sched-vs">vs</span>
                                {getTeamName(match, 1)}
                            </div>
                            <div className="sched-venue">
                                Virtual IPL · {match.matchId}
                            </div>
                        </div>
                        <div className="sched-right">
                            <div className="fmt-chip">VIRTUAL</div>
                        </div>
                    </div>
                ))}

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    loading={loading}
                />
            </div>
        </div>
    );
}

export default Schedule;